import { Address } from "../dataDefinitions/address";

export const getEmptyAddressObj = (): Address => ({
    lines: null,
    city: null,
    country_subdivision: null,
    country: null,
    postal_code: null,
});
